import { Form as AntForm } from "antd"
import * as React from "react"
import styled from "styled-components"

export const StyledForm = styled(AntForm)`
  max-width: 732px;
  display: block;
  padding: 2rem 4rem;
`
export const Form = ({
  children,
  ...props
}: React.ComponentProps<typeof StyledForm>) => {
  return <StyledForm {...props}>{children}</StyledForm>
}
